import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import { useApiClient } from '@/hooks'
import { ExpenseDeclaration, APIErrorResponse } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'
import { getUseExpensesKey } from './useExpenses'

export type PostExpenseDeclarationDecline = {
  validation_message: string
}

export const usePostExpenseDeclarationDecline = ({
  id,
}: Pick<ExpenseDeclaration, 'id'>): UseMutationResult<
  ExpenseDeclaration,
  APIErrorResponse,
  PostExpenseDeclarationDecline
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const expensesListKey = getUseExpensesKey()

  return useMutation(
    (params) =>
      client
        .post(`/hours_reporting/hr/expenses/${id}/decline/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(expensesListKey)
      },
    }
  )
}
